import React, { useEffect, useState } from 'react'

export default function RefundAlert({title, text, type, onHide}) {
  useEffect(() => { setTimeout(onHide, 6000) }, [])

  return (
    <div className='transactions-history__alert'>
      <div className='title'>{title}</div>
      <div className='description'>{text}</div>
    </div>
  )
}
